import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

export const useCopyText = () => {
  const { t } = useTranslate();

  return (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.success(t('trade.复制成功'));
      })
      .catch(() => {
        message.error(t('trade.复制失败'));
      });
  };
};
